import { useState, useEffect } from "react";
import { Navbar, Collapse, Button, IconButton } from "@material-tailwind/react";
import { logo, menu, close } from "../../assets";
import { navLinks } from "./Navlink";

const Header = () => {
  const [openNav, setOpenNav] = useState(false);
  const [active, setActive] = useState("Home");

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false)
    );
  }, []);

  const navList = (
    <ul className="mb-4 mt-4 flex justify-center flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center">
      {navLinks.map((nav) => (
        <li key={nav.id} onClick={() => setActive(nav.title)}>
          <a href={`#${nav.id}`}>
            <Button
              variant="text"
              className={`${
                active === nav.title
                  ? "text-blue-900 text-[13px]"
                  : "text-blue-700"
              }`}
            >
              {nav.title}
            </Button>
          </a>
        </li>
      ))}
    </ul>
  );

  return (
    <>
      <Navbar className="mx-auto max-w-screen-lg lg:py-3 lg:rounded-3xl bg-gradient-to-t from-cyan-300  lg:bg-none lg:bg-blue-50 ">
        <div className="flex items-center justify-between sm:justify-around ">
          <img
            src={logo}
            alt="logo"
            className="h-9 hover:bg-cyan-300 duration-300 hover:rounded-full hover:p-0.5 cursor-pointer"
          />
          <div className="flex items-center">
            <div className="mr-4 hidden lg:block">{navList}</div>

            <IconButton
              variant="text"
              className="ml-auto h-10 w-10 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
              ripple={false}
              onClick={() => setOpenNav(!openNav)}
            >
              <img
                src={openNav ? close : menu}
                alt="menu"
                className="w-[21px] h-[21px] object-contain "
                onClick={() => setOpenNav(!openNav)}
              />
            </IconButton>
          </div>
        </div>
        <Collapse open={openNav}>{navList}</Collapse>
      </Navbar>
    </>
  );
};

export default Header;
